export const sendViaMultiChannel = async (leadData, messages) => {
  try {
    console.log('🚀 Sending via multiple channels:', leadData);

    const response = await fetch('/api/send-lead-multi', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        leadData: leadData || {},
        messages: messages || []
      })
    });

    const responseText = await response.text();
    console.log('📨 Raw response:', responseText);

    let result;
    try {
      result = JSON.parse(responseText);
    } catch (parseError) {
      throw new Error(`Invalid response format: ${responseText}`);
    }

    if (!response.ok) {
      throw new Error(result.error || `HTTP ${response.status}`);
    }

    return result;

  } catch (error) {
    console.error('❌ Multi-channel API Error:', error);
    throw new Error(error.message || 'Failed to send lead');
  }
};
